import { Component, Input, OnInit } from '@angular/core';
import { CourierProfileService } from '../../shared/services/courier-profile.service';
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-courier-logo',
    templateUrl: './courier-logo.component.html',
    styleUrls: ['./courier-logo.component.scss'],
    imports: [AsyncPipe]
})
export class CourierLogoComponent {

    private inputCourierModule$ = new BehaviorSubject<string>(null);
    private inputServiceLogo$ = new BehaviorSubject<string>(null);

    @Input()
    set courierModule(value: string) {
        this.inputCourierModule$.next(value);
    }

    @Input()
    set serviceLogo(value: string) {
        this.inputServiceLogo$.next(value);
    }

    @Input()
    size: 'table' | 'default' = 'default';

    constructor(private courierProfileService: CourierProfileService) {
    }

    public url$: Observable<string> = combineLatest([ this.inputCourierModule$, this.inputServiceLogo$ ]).pipe(
        filter(([ courierModule, serviceLogo ]) => !!courierModule || !!serviceLogo),
        switchMap(([ courierModule, serviceLogo ]) => serviceLogo ? of(serviceLogo) :
            this.courierProfileService.getCourierDetail(courierModule).pipe(
                map(courier => courier.logo)
            )
        )
    );

}
